<template>

  <mdc-dialog v-model="isOpen"
              :title="'profile.edit_clinic_center' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              :accept-disabled="disabled"
              @accept="close"
              @cancel="close"
              @validate="save">
    <div class="close-cross" @click="close()">
      <mdc-icon icon="close"></mdc-icon>
    </div>
    <loader v-if="!isLoaded" class="table-loader"></loader>
    <form enctype="multipart/form-data" novalidate>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="clinicName"
                         type="text"
                         :label="'profile.name_clinic_center' | trans"
                         name="clinicName"
                         :class="{'is-invalid': errors.has('clinicName')}"
                         v-validate="{required: true, min: 5}"
                         v-model="clinicName.name"
                         autocomplete="new-clinicName"
                         data-vv-validate-on="none"
                         :data-vv-as="'profile.name_clinic_center' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('clinicName') && errors.firstRule('clinicName') != 'regex'">
                        <strong>{{ errors.first('clinicName') }}</strong>
                    </span>

          <span class="invalid-feedback"
                v-if="errors.firstRule('clinicName') === 'regex' ">
                        <strong>{{'validation.regex', {attribute: clinicalName} | trans}}</strong>
                    </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="clinicName"
                         type="text"
                         :label="'profile.legalName' | trans"
                         name="legalName"
                         :class="{'is-invalid': errors.has('legalName')}"
                         v-validate="{required: false, max: 255}"
                         v-model="clinicName.legalName"
                         data-vv-validate-on="none"
                         :data-vv-as="'profile.legalName' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('legalName') && errors.firstRule('legalName') != 'regex'">
                        <strong>{{ errors.first('legalName') }}</strong>
                    </span>

          <span class="invalid-feedback"
                v-if="errors.firstRule('clinicName') === 'regex' ">
                        <strong>{{'validation.regex', {attribute: clinicalName} | trans}}</strong>
                    </span>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="phone"
                         type="tel"
                         :label="'profile.phone' | trans"
                         name="phone"
                         :class="{'is-invalid': errors.has('phone')}"
                         v-validate="'required|numeric|min:5|max:13'"
                         v-model="clinicName.phone"
                         data-vv-validate-on="none"
                         :data-vv-as="'profile.phone' | trans"/>
          <span class="invalid-feedback" v-if="errors.has('phone')">
              <strong>{{ errors.first('phone') }}</strong>
          </span>
        </div>
      </div>


      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="address"
                         type="text"
                         :label="'profile.address'| trans"
                         name="address"
                         :class="{'is-invalid': errors.has('address')}"
                         v-validate=""
                         v-model="clinicName.address"
                         v-bind:value="clinicName.address"
                         v-on:input="$emit('input', $event.target.value)"
                         data-vv-validate-on="none"
                         autocomplete="new-address"
                         :data-vv-as="'profile.address' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('address')">
            <strong>{{errors.first('address') }}</strong>
                        </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="email"
                         type="text"
                         :label="'contact_us.labels.email'| trans"
                         name="email"
                         :class="{'is-invalid': errors.has('email')}"
                         v-validate="'required|email'"
                         v-model="clinicName.email"
                         v-bind:value="clinicName.email"
                         v-on:input="$emit('input', $event.target.value)"
                         data-vv-validate-on="none"
                         autocomplete="new-address"
                         :data-vv-as="'validation.attributes.email' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('email')">
            <strong>{{errors.first('email') }}</strong>
                        </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <div class="mdc-textfield mdc-text-field mdc-text-field--upgraded mdc-text-field--textarea" :class="{'is-invalid': errors.has('other_contact')}">
             <textarea rows="4" cols="40" v-model="clinicName.socialNetwork"
                            id="other_contact"
                            class="mdc-text-field__input"
                            v-on:input="$emit('input', $event.target.value)"
                            name="other_contact"
                            data-vv-validate-on="none"
                            :data-vv-as="'profile.other_contact' | trans"/>
            <label for="other_contact" class="mdc-floating-label mdc-floating-label--float-above"> {{'profile.other_contact' | trans}} </label>
          </div>
          <span class="invalid-feedback"
                v-if="errors.has('other_contact')">
            <strong>{{ errors.first('other_contact')}}</strong>
          </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <div class="float-left mr-2 mb-2 wrapp-logo" v-if="logoUrl">
            <img :src="logoUrl" alt="">
          </div>
          <uploader v-on:fileuploadadd="onFileUploadAdd"
                    v-on:fileuploaddone="onFileUploadDone"
                    v-on:fileuploadfail="onFileUploadFail"
                    v-on:fileuploadprocessfail="onFileUploadProcessFail"
                    v-on:fileuploadremove="onFileUploadRemove"
                    :options=options
                    :class="{'is-invalid': errors.has('file')}"></uploader>
        </div>
      </div>

    </form>
  </mdc-dialog>

</template>

<script>
  import {mapActions} from 'vuex';
  import {Validator} from 'vee-validate';
  import lang from '../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';
  import cloneDeep from 'lodash/cloneDeep';
  import Loader from '../../loader/components/Loader';
  import axios from 'axios';
  import Uploader from '../../fileUpload/components/Uploader';
  import Manager from '../api/Manager';

  export default {
    name: 'ClinicalModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        clinicName: {
          name: null,
          phone: null,
          address: null,
          other_contact: null,
          logo: null,
          legalName: null
        },
        logoUrl: null,
        oldClinicName: {},
        isLoaded: true,
        disabled: false,
        clinicalName: lang.get('profile.name_clinic_center'),
        options: {
          formData: {
            type: 'image'
          },
          singleFileUploads: false,
          maxNumberOfFiles: 1
        }
      };
    },
    async created() {
      this.clinicName = this.data;
      this.logoUrl = this.clinicName.logo;
    },
    components: {
      Loader, Uploader
    },
    methods: {
      async save() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }

        try {
          let isSaved = await Manager.setClinicalCenter(this.clinicName, this.data.id);

          if (isSaved){
            this.close();
          }

        } catch (e) {
        } finally {
          this.disabled = false;
          this.isloading = true;
        }
      },
      reset() {
        console.log(this.$data);
        Object.assign(this.$data, this.$options.data());
        this.errors.clear();
      },
      close() {
        this.$emit('close');
        this.reset();
      },

      onFileUploadAdd() {
        this.disabled = true;
      },
      onFileUploadDone({name, url}) {
        this.clearFileError();
        this.disabled = false;
        this.clinicName.logo = name;
        this.logoUrl = url;
      },
      onFileUploadFail() {
        console.info("onFileUploadFail");
        this.disabled = false;
        this.addFileError()
        this.clinicName.logo = null;
      },
      onFileUploadProcessFail() {
        this.disabled = false;
        this.clinicName.logo = null;
      },
      onFileUploadRemove() {
        this.clinicName.logo = null;
      },
      addFileError(error = lang.get(
          'validation.required',
          {attribute: lang.get('validation.attributes.file')},
      )) {
        this.clearFileError();
        this.errors.add('file', error);
      },
      clearFileError() {
        this.errors.remove('file');
      }
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/ClinicalModal.vue